import React, { Component } from 'react';
import Button from '../../../components/button/Button';
import Toast from '../../../components/toast/Toast';
import { autoSyncTime } from '../../../service/command';

export default class QuitShutdown extends Component {
  onConfirm() {
    // 本机时间
    autoSyncTime().then(() => {
      this.props.closePanel();
      Toast.success('设置成功');
    }).catch((error) => {
      Toast.fail(error);
    });
  }

  render() {
    return (
      <div>
        <div style={{ textAlign: 'center', margin: '10px' }}>设置地磁自动校时</div>
        <div style={{ textAlign: 'center' }}>
          <Button type="primary" onClick={() => this.onConfirm()}>确认设置</Button>
        </div>
      </div>
    );
  }
}
